export const randomNumberId = () => {
  const nr = String(Math.random()).split('.')[1];

  if (Number(nr)) {
    return Number(nr);
  }

  return Math.random();
};
